import { createContext } from 'react';
import type { ToastProps } from '@components/NotificationsV2/Toast/Toast';
import type { OnNavigateProps } from '@utils/navigation-handler';
import type { HotsauceStrings } from '@strings';
import type { InterpolateFn } from '@utils/interpolate';

export type ToastData = {
  text: ToastProps['children'];
  kind: ToastProps['kind'];
  id: string;
};

export type AddToastProps = Omit<ToastData, 'id'>;

interface HotsauceContextInterface {
  addToast: (props: AddToastProps) => string;
  removeToast: (toastId: string) => void;
  onNavigate: (props: OnNavigateProps) => void;
  strings: HotsauceStrings;
  interpolate: InterpolateFn;
}

export const HotsauceContext =
  createContext<HotsauceContextInterface>(undefined);
